import { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { ReportingCriteria } from '../../../../types/Criteria/ReportingCriteria';

interface ReportingCampaignStrategyTypeSelectProps {
    reportingCriteria: ReportingCriteria;
    onChangeReportingCriteria: (reportingCriteria: ReportingCriteria) => void;
    strategyTypes?: Record<string, string>;
    disabled?: boolean;
}

export default function ReportingCampaignStrategyTypeSelect(props: ReportingCampaignStrategyTypeSelectProps) {
    const { reportingCriteria, onChangeReportingCriteria, disabled = false } = props;

    const options: Record<string, string> = useMemo(() => {
        return {
            '': 'All',
            ...props.strategyTypes,
        };
    }, [props.strategyTypes]);

    const handleChange = (event: SelectChangeEvent): void => {
        onChangeReportingCriteria({
            ...reportingCriteria,
            strategyType: event.target.value,
        });
    };

    return (
        <FormControl fullWidth size="small" disabled={disabled}>
            <InputLabel id="campaignStrategyTypeLabel" shrink>
                Campaign Strategy
            </InputLabel>
            <Select
                displayEmpty
                labelId="campaignStrategyTypeLabel"
                id="campaignStrategyType"
                value={reportingCriteria.strategyType}
                label="Campaign Strategy"
                onChange={handleChange}
            >
                {Object.entries(options).map(([value, label]) => (
                    <MenuItem key={value} value={value}>
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
